import { render, staticRenderFns } from "./DiaryEntries.vue?vue&type=template&id=72947612&scoped=true"
import script from "./DiaryEntries.vue?vue&type=script&lang=js"
export * from "./DiaryEntries.vue?vue&type=script&lang=js"
import style0 from "./DiaryEntries.vue?vue&type=style&index=0&id=72947612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72947612",
  null
  
)

export default component.exports